import { BaseIcon } from './BaseIcon';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeSvg = () => {
  return /*#__PURE__*/_jsx(BaseIcon, {
    children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
  });
};